import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Contact.css";
import ContactInfo from "./ContactInfo";
import Select from "react-select";

function Contact() {
  const [selectedServices, setSelectedServices] = useState([]);
  const location = useLocation();

  // 👇 This useEffect handles auto-scroll to form when URL has #contactForm
  useEffect(() => {
    if (location.hash === "#contactForm") {
      const element = document.getElementById("contactForm");
      if (element) {
        // Small delay ensures DOM is ready before scrolling
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    }
  }, [location]);

  // 👇 This useEffect handles form submission logic
  useEffect(() => {
    const form = document.querySelector("form");

    const handleSubmit = async (e) => {
      e.preventDefault();

      const formData = new FormData(form);

      // Add services manually
      const services = selectedServices.map((s) => s.value).join(", ");
      formData.set("services", services);

      let message = "";

      // Loop through all form fields
      formData.forEach((value, key) => {
        if (value && value.trim() !== "") {
          // Only add field if it is FILLED
          message += `${key}: ${value}\n`;
        }
      });

      const phone = "919624883636";
      const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(
        message
      )}&type=phone_number&app_absent=0`;

      window.open(whatsappUrl, "_blank");

      alert("✅ Your message is ready to send on WhatsApp!");
      form.reset();
      setSelectedServices([]);
    };

    if (form) {
      form.addEventListener("submit", handleSubmit);
    }

    return () => {
      if (form) {
        form.removeEventListener("submit", handleSubmit);
      }
    };
  }, [selectedServices]);


  // --- Service Options and Custom Styles ---
  const serviceOptions = [
    { value: "Google Ads", label: "Google Ads" },
    { value: "Shopify Store Development", label: "Shopify Store Development" },
    { value: "SEO / Marketing", label: "SEO / Marketing" },
    {
      value: "Social Media Ads (Facebook/Instagram)",
      label: "Social Media Ads (Facebook/Instagram)",
    },
    {
      value: "Social Media Optimization (SMO)",
      label: "Social Media Optimization (SMO)",
    },
    {
      value: "Search Engine Optimization (SEO)",
      label: "Search Engine Optimization (SEO)",
    },
    {
      value: "Website Design & Development",
      label: "Website Design & Development",
    },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      padding: "2px",
      borderColor: "#ced4da",
      boxShadow: "none",
      minHeight: "38px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#e9ecef"
          : "#fff",
      color: state.isSelected ? "#fff" : "#000",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#007bff",
      color: "white",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "white",
    }),
  };

  return (
    <div className="contact-page">
      <section className="contact-header"></section>

      {/* Contact Info Cards */}
      <ContactInfo />

      {/* Contact Form + Photo */}
      <section className="contact-form-section">
        <div className="contact-form-container">
          {/* Left Side (Form) */}
          <div className="contact-form">
            <h2>Let’s Talk Growth</h2>
            <p>
              Have a project in mind or need a custom digital strategy? We’d love
              to hear from you.
            </p>

            <form id="contactForm">
              <div className="mb-3">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Full name"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter email"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  name="phone"
                  type="text"
                  className="form-control"
                  placeholder="Phone number"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  name="company"
                  className="form-control"
                  placeholder="Company"
                />
              </div>
              <div className="mb-3">
                <input
                  type="url"
                  name="website"
                  className="form-control"
                  placeholder="Website URL"
                />
              </div>

              {/* ✅ Replaced <select> with react-select */}
              <div className="row g-2 mb-3">
                <div className="col-md-6">
                  <Select
                    isMulti
                    options={serviceOptions}
                    value={selectedServices}
                    onChange={setSelectedServices}
                    styles={customStyles}
                    placeholder="Choose Service"
                    classNamePrefix="select"
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="text"
                    name="budget"
                    className="form-control"
                    placeholder="Approx Budget Ex:- $1000"
                  />
                </div>
              </div>

              <div className="mb-3">
                <textarea
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Message..."
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </div>

          {/* Right Side (Photo) */}
          <div className="contact-photo">
            <img src="/assets/contactperson.png" alt="Contact Person" />
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <iframe
          title="Our Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4469.330010889891!2d72.84553882589174!3d21.240076580485795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04ed6f10c03d9%3A0x7f6ccacae2c6e8fd!2sNew%20Escon%20plaza!5e1!3m2!1sen!2sin!4v1761989422252!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </div>
  );
}

export default Contact;
